import Vue from "vue"
import VueRouter from "vue-router"

Vue.use(VueRouter)

const routes = [
    // {
    //   path: "*",
    //   name: "index",
    //   component: () =>
    //     import(/* webpackChunkName: "Public" */ "../views/Public.vue"),
    // },
    {
        path: "/",
        name: "index",
        redirect: "/public/",
        component: () =>
      import(/* webpackChunkName: "Index" */ "../views/Index.vue"),
        children: [
            {
                path: "/public/*",
                name: "public",
                component: () =>
          import(/* webpackChunkName: "Public" */ "../views/Public.vue")
            },
            {
                path: "/publicold/*",
                name: "old",
                component: () =>
          import(/* webpackChunkName: "Public" */ "../views/PublicOld.vue")
            },
            {
                path: "/taskList",
                name: "taskList",
                component: () =>
          import(/* webpackChunkName: "Public" */ "../views/taskList.vue")
            },
            {
                path: "/unExpiredFile",
                name: "unExpiredFile",
                component: () =>
          import(/* webpackChunkName: "public" */ "../views/unExpiredFile.vue")
            },
            {
                path: "/test",
                name: "test",
                component: () =>
          import(/* webpackChunkName: "public" */ "../views/About.vue")
            },
            {
                path: "/recycle",
                name: "recycle",
                component: () =>
          import(/* webpackChunkName: "public" */ "../views/recycle.vue")
            },
            {
                path: "/accessRequest",
                name: "accessRequest",
                component: () =>
          import(/* webpackChunkName: "public" */ "../views/accessRequest.vue")
            },
            {
                path: "/accessManage",
                name: "accessManage",
                component: () =>
          import(/* webpackChunkName: "public" */ "../views/accessManage.vue")
            }
        ]
    },
    {
        path: "/download",
        name: "download",
        component: () =>
      import(
          /* webpackChunkName: "download" */ "../views/commonPage/download.vue"
      )
    },
    {
        path: "/upload",
        name: "upload",
        component: () =>
      import(/* webpackChunkName: "upload" */ "../views/commonPage/upload.vue")
    },
    {
        path: "/collectupload",
        name: "collectupload",
        component: () =>
      import(
          /* webpackChunkName: "collectupload" */ "../views/commonPage/collectupload.vue"
      )
    },
    {
        path: "/linkinvalid",
        name: "linkinvalid",
        props: route => ({ names: route.query.name }),
        component: () =>
      import(
          /* webpackChunkName: "linkinvalid" */ "../views/commonPage/linkinvalid.vue"
      )
    },
    {
        path: "/nopermission",
        name: "nopermission",
        component: () =>
      import(
          /* webpackChunkName: "linkinvalid" */ "../views/commonPage/nopermission.vue"
      )
    },
    {
        path: "/noauthority",
        name: "noauthority",
        component: () =>
      import(
          /* webpackChunkName: "linkinvalid" */ "../views/commonPage/noauthority.vue"
      )
    }
]

const router = new VueRouter({
    mode: "history",
    base: "/web/",
    routes
})
// console.log(router);
export default router
